import { Button, Typography } from "components/ui";
import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { useIsMobile } from "utils/hooks/useIsMobile";
import CheckBox from "expo-checkbox";
import { SiteSelect } from "components/form/SiteSelect";
import { useToken } from "@gluestack-style/react";
import { EquipmentTypeSelect } from "components/form/EquipmentTypeSelect";

type Props = {
	onSiteChage: (site: any) => void;
	onEquipmentTypeChange: (equipmentType: any) => void;
	onIsHireChange: (isHire: boolean | undefined) => void;
};

const EquipmentFilter = ({ onSiteChage, onEquipmentTypeChange, onIsHireChange }: Props) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const [showHireEquipments, setShowHireEquipments] = React.useState(false);
	const [selectedEquipmentTypes, setSelectedEquipmentTypes] = React.useState<any[]>([]);

	const handleSiteChange = (site: any) => {
		onSiteChage(site);
	};

	const handleEquipmentTypeChange = (equipmentType: any) => {
		setSelectedEquipmentTypes(equipmentType);
		onEquipmentTypeChange(equipmentType);
	};

	const handleIsHireChange = (isHire: boolean) => {
		setShowHireEquipments(isHire);
		if (isHire) {
			onIsHireChange(true);
		} else {
			onIsHireChange(undefined);
		}
	};

	return (
		<GridContainer
			noPadding
			style={{
				marginLeft: 0,
				maxWidth: "100%",
				marginBottom: 12,
				gap: 24,
				zIndex: 9,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
		>
			<Row style={{ gap: isMobile ? 12 : 0, position: "relative", zIndex: 10 }}>
				<Col xs={12} md={3}>
					<SiteSelect onSelect={handleSiteChange} />
				</Col>
				<Col xs={12} md={3}>
					<EquipmentTypeSelect label="Equipment Type" onSelect={handleEquipmentTypeChange} value={selectedEquipmentTypes} />
				</Col>

				{/* <Col xs={12} md={3}>
					<Button onPress={() => handleIsHireChange(!showHireEquipments)} justifyContent="flex-start" paddingHorizontal={0} gap={4} alignItems="center" marginTop={0} marginBottom={0}>
						<CheckBox color={"#2B6FBB"} value={showHireEquipments} />
						<Typography>Only show hired equipments</Typography>
					</Button>
				</Col> */}
			</Row>
		</GridContainer>
	);
};

export default EquipmentFilter;
